(function () {
  "use strict";

  angular
    .module("admin.users.details.roles", ["admin.users.details.roles.service"])
    .controller("UserRolesCtrl", UserRolesCtrl);

  /** @ngInject */
  function UserRolesCtrl($stateParams, UserRolesService) {
    var vm = this;
    vm.items = [];
    vm.perPage = 25;
    vm.userId = $stateParams.parentId;

    function reloadPagination() {
      vm.totalItems = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    reloadPagination();

    vm.types = [
      { id: 1, name: "Producer" },
      { id: 2, name: "Employee" },
    ];

    vm.levels = [
      { id: 1, name: "Level1" },
      { id: 2, name: "Level2" },
      { id: 3, name: "Level3" },
    ];

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      UserRolesService.list(vm.userId, vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        vm.items = result.results;
      });
    }

    load(1);

    vm.load = function () {
      reloadPagination();
      load(1);
    };

    vm.pageChanged = function (newPage) {
      load(newPage);
      $("html, body").animate({ scrollTop: 0 }, 0);
    };

    vm.create = function () {
      vm.model = {
        id: 0,
        k: 0,
        lvl: 0,
        "id-u": parseInt(vm.userId),
      };
      $("#myModal").modal("show");
    };

    vm.edit = function (item) {
      vm.model = item;
      $("#myModal").modal("show");
    };

    vm.save = function () {
      if (vm.model.id > 0) {
        UserRolesService.update(vm.model.id, vm.model).then(function () {
          $("#myModal").modal("hide");
          vm.load();
        });
      } else {
        delete vm.model.id;
        UserRolesService.save(vm.model).then(function () {
          $("#myModal").modal("hide");
          vm.load();
        });
      }
    };

    vm.delete = function (item) {
      swal(
        {
          title: "Are you sure?",
          text: "",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            UserRolesService.remove(item.id).then(
              function () {
                vm.load();
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          }
        }
      );
    };
  }
})();
